// extracted by mini-css-extract-plugin
export default {"container":"styles_container__EwoPl","title":"styles_title__9hYcv","wrapper":"styles_wrapper__bZ92l","footer":"styles_footer__IF6wv"};